<template>
    <div>
        <div class="component-detail">
            <div class="component-detail-row">
                <div class="component-detail-title">
                    <b>Report Type</b>
                </div>
                <div class="component-detail-content">
                    {{reportType}}
                </div>
            </div>

            <div class="component-detail-row">
                <div class="component-detail-title">
                    <b>Upload Date</b>
                </div>
                <div class="component-detail-content">
                    {{uploadDateParsed}}
                </div>
            </div>

            <div class="component-detail-row">
                <div class="component-detail-title">
                    <b>Report Description</b>
                </div>
                <div class="component-detail-content">
                    {{reportDescriptionParsed}}
                </div>
            </div>

            <div v-if="docIds.length > 0" class="component-detail-row">
                <div class="component-detail-title">
                    <b>Report Download</b>
                </div>
                <div class="component-detail-content">
                    <a v-for="(docId, index) in docIds" class="btn btn-primary btn-primary-insv mr-2" :key="index" :href="`${apiPath}MedicalReport/DownloadReportById?reportId=${docId}&token=${token}`" download>Download File {{ index + 1 }}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    convertToUserReadableDate,
    replaceLineBreakInHtml
} from '@/utilities';
import { apiPath } from '@/config';
import Cookies from 'js-cookie';
export default {
    'name': 'MedicalReportDetailComponent',
    'computed': {
        uploadDateParsed () {
            return this.uploadDate ? convertToUserReadableDate(this.uploadDate) : '-';
        },
        reportDescriptionParsed () {
            return this.reportDescription ? replaceLineBreakInHtml(this.reportDescription) : '-';
        },
        token () {
            return Cookies.get('t');
        }
    },
    'props': {
        'reportType': {
            'type': String,
            'default': ''
        },
        'uploadDate': {
            'type': String,
            'default': ''
        },
        'reportDescription': {
            'type': String,
            'default': ''
        },
        'reportDownloadLink': {
            'type': String,
            'default': ''
        },
        'docIds': {
            'type': Array,
            'default': () => { return []; }
        }
    },
    'data': function () {
        return {
            'apiPath': apiPath
        };
    }
};

</script>

<style>

</style>
